import { useQuery } from "@tanstack/react-query";

import { queries } from "./factories";

type UseInsurancesListQueryParams = {
  stateId: number | null;
  eligibility?: string[];
};

export const useInsurancesListQuery = ({
  stateId,
  eligibility,
}: UseInsurancesListQueryParams) => {
  return useQuery({
    ...queries.list({ stateId: stateId as number, eligibility }),
    enabled: !!stateId,
  });
};
